<template>
  <div class="BaseLoginForm-container">
    <div v-if="isShowImgVerif" class="my-imgverif-wrap">
      <BaseImgVerif :fullscreen="false" @success="sendCode" @close="toggleImgVerif(false)" />
    </div>
    <div class="my-logowrap">
      <img v-if="mode === 'cg'" class="my-logo" src="@/assets/logo_cg.png" alt="橙光游戏" />
      <img v-else class="my-logo" alt="木夕阅读" src="@/assets/logo.png" />
    </div>
    <div class="my-tabs clearfix">
      <div class="my-tab ut-cp" @click="changeTab(1)" :class="{ 'my-active': activeIdx == 1 }">
        快捷登录
      </div>
      <div class="my-tab ut-cp" @click="changeTab(2)" :class="{ 'my-active': activeIdx == 2 }">
        账号登录
      </div>
      <hr class="my-actline" :style="actLineStyle" />
    </div>
    <div class="my-body">
      <div class="my-form">
        <div
          class="my-inputgroup clearfix"
          :class="{ 'my-inputgroup-witharea': isByPhoneWithArea }"
        >
          <select v-if="isByPhoneWithArea" v-model="activeAreaCode" @change="resetError(formPhone)">
            <option v-for="item in areaCodeList" :value="item.value" :key="item.value"
              >{{ item.title }} {{ item.label }}</option
            >
          </select>
          <div v-if="!isByFormUser" class="my-inputwrap">
            <i class="my-inputicon my-inputicon_phone"></i>
            <input
              type="tel"
              name="mobile"
              v-model="formPhone.value"
              placeholder="请输入手机号"
              @input="resetError(formPhone)"
              @keyup.enter="doLogin()"
            />
            <p v-if="formPhone.error" class="my-inputtip">手机号码格式有误</p>
          </div>
          <div v-else class="my-inputwrap">
            <i class="my-inputicon my-inputicon_phone"></i>
            <input
              type="text"
              name="account"
              v-model="formUser.value"
              :placeholder="'请输入手机号/用户名'"
              @input="resetError(formUser)"
              @keyup.enter="doLogin()"
            />
            <p v-if="formUser.error" class="my-inputtip">手机号或用户名格式有误</p>
          </div>
        </div>
        <div v-if="activeIdx == 2" class="my-inputwrap">
          <i class="my-inputicon my-inputicon_psw"></i>
          <input
            type="password"
            name="password"
            v-model="formPsw.value"
            placeholder="请输入密码"
            @input="resetError(formPsw)"
            @keyup.enter="doLogin()"
          />
          <p v-if="formPsw.error" class="my-inputtip">密码格式有误</p>
        </div>
        <div v-if="activeIdx == 1" class="my-inputgroup clearfix my-inputgroup-withcode">
          <div class="my-inputwrap">
            <i class="my-inputicon my-inputicon_code"></i>
            <input
              type="text"
              name="code"
              v-model="formCode.value"
              placeholder="请输入验证码"
              @input="resetError(formCode)"
              @keyup.enter="doLogin()"
            />
          </div>
          <div
            class="my-inputbtn"
            :class="{ 'js-is-wait': isWaitCode }"
            @click="mode === 'cg' ? sendCode() : toggleImgVerif(true)"
          >
            {{ waitText }}
          </div>
          <p v-if="formCode.error" class="my-inputtip">验证码格式有误</p>
        </div>
        <div v-if="activeIdx == 2 && mode === 'mx'" class="my-forgetpsw ut-cp">
          <span @click="forgetPsw">忘记密码</span>
        </div>
        <div v-else class="my-forgetpsw"></div>
        <div class="my-loginbtn ut-cp" @click="doLogin()">
          {{ isNewBind ? '登录并绑定' : '登录' }}
        </div>
        <p class="my-logindesc">
          登录{{ platName }}，即代表您同意
          <em @click="toggleAgree(true)">《{{ platName }}用户协议》</em>
        </p>
        <div v-if="mode === 'mx'" class="my-loginby">
          其他登录方式：
          <span
            class="my-loginicon my-loginicon_wx"
            title="微信账号登录"
            @click="setModeLogin('wx')"
          ></span>
          <span
            class="my-loginicon my-loginicon_cg"
            title="橙光账号登录"
            @click="setModeLogin('cg')"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import $ from 'jquery'
import { areaCodeList } from '@/constants'
import BaseImgVerif from '@/components/BaseImgVerif'

export default {
  name: 'BaseLoginForm',
  components: {
    BaseImgVerif
  },
  props: ['mode', 'defaultIdx', 'isNewBind'],
  data() {
    return {
      activeIdx: 1,
      actLineStyle: {
        left: 0
      },
      isWaitCode: false,
      isFirstSend: true, // 是否第一次发送验证码
      isShowImgVerif: false,
      waitCount: 60,
      waitTimer: null,
      formUser: {
        value: '',
        error: false
      },
      formPhone: {
        value: '',
        error: false
      },
      formPsw: {
        value: '',
        error: false
      },
      formCode: {
        value: '',
        error: false
      },
      activeAreaCode: '86',
      areaCodeList
    }
  },
  computed: {
    waitText() {
      return this.isWaitCode
        ? `(${this.waitCount}s)后重发`
        : this.isFirstSend
        ? '获取验证码'
        : '重新发送'
    },
    platName() {
      return this.mode === 'cg' ? '橙光阅读' : '木夕'
    },
    isByFormUser() {
      // 是否使用用户名登录
      return this.mode === 'cg' && this.activeIdx == 2
    },
    isByPhoneWithArea() {
      // return this.mode !== 'cg' && this.activeIdx == 1 // PS: 已修改为手机号密码登录时也需选择地区
      return this.mode !== 'cg'
    }
  },
  watch: {
    isWaitCode(v) {
      clearInterval(this.waitTimer)
      if (v) {
        this.isFirstSend = false
        this.waitCount = 60
        this.waitTimer = setInterval(() => {
          this.waitCount--
          if (!this.waitCount) this.isWaitCode = false
        }, 1000)
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.defaultIdx) this.changeTab(this.defaultIdx)
    },
    // hex 加密算法
    hexEncode(str) {
      var hex, i
      var result = ''
      for (i = 0; i < str.length; i++) {
        hex = str.charCodeAt(i).toString(16)
        result += ('0' + hex).slice(-2)
      }
      return result
    },
    // 加密算法
    encryptXor(text, key) {
      var result = ''
      for (var i = 0; i < text.length; i++) {
        result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length))
      }
      return result
    },
    encodeUnicode(str) {
      var res = []
      for (var i = 0; i < str.length; i++) {
        res[i] = ('00' + str.charCodeAt(i).toString(16)).slice(-4)
      }
      return '\\u' + res.join('\\u')
    },
    changeTab(idx) {
      if (idx != this.activeIdx) this.resetError()
      this.activeIdx = idx
      this.actLineStyle = Object.assign({}, this.actLineStyle, {
        left: idx == 2 ? '50%' : 0
      })
    },
    forgetPsw() {
      this.$store.commit('vx_setData', {
        vx_loginDefaultIdx: 2
      })
      this.$router.push('/resetpsw')
    },
    toggleAgree(v) {
      this.$emit('toggleAgree', v)
    },
    toggleImgVerif(v = !this.isShowImgVerif) {
      if (v) {
        if (this.isWaitCode) return
        if (!this.checkForm({ from: 'send_code' })) return
      }
      this.isShowImgVerif = v
    },
    sendCode() {
      if (this.isWaitCode) return
      if (!this.checkForm({ from: 'send_code' })) return
      this.isWaitCode = true
      this.formCode.value = ''
      if (this.mode === 'cg') this.xhrSendCode_cg()
      else this.xhrSendCode_mx()
    },
    // 发送验证码 - 木夕
    xhrSendCode_mx() {
      this.$api
        .sendCodeForLogin({
          mobile: this.formPhone.value,
          typeCode: this.activeAreaCode
        })
        .then(res => {
          if (res.isOk) {
            this.$toast('发送成功')
          } else {
            this.isWaitCode = false
            this.$toast(res.msg || (res.message || {}).title || '发送失败')
          }
        })
        .catch(e => {
          console.error('获取验证码失败', e)
          this.$toast('网络连接失败')
          this.isWaitCode = false
        })
    },
    // 发送验证码 - 橙光
    xhrSendCode_cg() {
      let _code = this.encryptXor(
        JSON.stringify({
          mobile: this.formPhone.value,
          timestamp: parseInt(new Date().getTime() / 1000)
        }),
        'brv@eeLzXaXdHDdq'
      )
      _code = this.hexEncode(_code)
      let url =
        this.$api._ut.getBaseURL_org() +
        '/interapi/Muxi/V1/LoginSDK/send_verification_code' +
        `?auth=${_code}`
      // 发送验证码
      $.ajax({
        url,
        method: 'get',
        timeout: 15000,
        dataType: 'jsonp',
        jsonp: 'jsonCallBack',
        success: res => {
          if (res.status == 1) {
            this.$toast(res.msg || '发送成功')
          } else {
            this.isWaitCode = false
            this.$toast(res.msg || '发送失败')
          }
        },
        error: e => {
          console.error('获取验证码失败', e)
          this.$toast('网络连接失败')
          this.isWaitCode = false
        }
      })
    },
    resetError(item) {
      if (item) item.error = false
      else
        [this.formPhone, this.formUser, this.formPsw, this.formCode].forEach(d => (d.error = false))
    },
    checkForm(config = {}) {
      this.resetError()
      let res = false // 是否有错
      if (this.isByFormUser) {
        this.formUser.error = !this.formUser.value // 非空
        res = res || this.formUser.error
      } else if (this.isByPhoneWithArea) {
        let v = this.formPhone.value
        let item = this.areaCodeList.find(d => d.value == this.activeAreaCode)
        this.formPhone.error = !(item && v.length == item.len && item.reg.test(v))
        res = res || this.formPhone.error
      } else {
        this.formPhone.error = !/^\d+$/.test(this.formPhone.value) // 纯数字
        res = res || this.formPhone.error
      }
      if (config.from !== 'send_code') {
        if (this.activeIdx == 2) {
          this.formPsw.error =
            this.mode === 'cg' ? this.formPsw.value.length < 4 : !this.formPsw.value // 非空
          res = res || this.formPsw.error
        } else {
          this.formCode.error = !this.formCode.value // 非空
          res = res || this.formCode.error
        }
      }
      // 没有错误则返回true
      return !res
    },
    setModeLogin(v) {
      this.$emit('setModeLogin', v)
    },
    doLogin: _.throttle(
      function() {
        let el = document.activeElement
        el && el.blur()
        if (!this.checkForm()) return
        this.$emit('login', this)
      },
      2000,
      { trailing: false }
    )
  }
}
</script>

<style lang="less" scoped>
.BaseLoginForm-container {
  position: relative;
}

.my-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.my-wrap {
  position: relative;
  top: 50%;
  width: 404px;
  height: 506px;
  margin: 0 auto;
  padding: 0 50px;
  background: #ffffff;
  transform: translateY(-50%);
}

.my-logowrap {
  text-align: center;
}

.my-logo {
  height: 50px;
  margin: 30px auto 40px;
}

.my-tabs {
  position: relative;
  border-bottom: 1px solid #dddddd;
}

.my-tab {
  display: inline-block;
  width: 50%;
  line-height: 28px;
  padding-bottom: 7px;
  font-size: 20px;
  color: #999999;
  text-align: center;
  &.my-active {
    color: #333333;
  }
}

.my-actline {
  position: absolute;
  bottom: 0;
  width: 50%;
  border-color: #4b85ff;
  transition: all 0.3s;
}

.my-inputgroup {
  position: relative;
  margin-top: 30px;
}

.my-inputgroup-witharea {
  select {
    float: left;
    width: 105px;
    height: 50px;
    line-height: 50px;
    margin-right: 15px;
    padding-left: 5px;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
    color: #333;
    box-sizing: border-box;
    outline: none;
    &,
    option {
      font-size: 16px;
    }
  }
  .my-inputwrap {
    float: left;
    width: calc(100% - 120px);
    margin-top: 0;
  }
}

.my-inputgroup-withcode {
  .my-inputwrap {
    float: left;
    width: 60%;
    margin-top: 0;
    margin-right: 15px;
  }
  .my-inputbtn {
    float: left;
    width: calc(40% - 15px);
  }
}

.my-inputbtn {
  line-height: 46px;
  text-align: center;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  color: #4b85ff;
  cursor: pointer;
  &.js-is-wait {
    color: #a6a6a6;
  }
}

.my-inputwrap {
  position: relative;
  height: 50px;
  margin-top: 30px;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  input {
    width: 100%;
    height: 100%;
    line-height: 28px;
    padding: 10px 10px 10px 40px;
    font-size: 16px;
    color: #333;
    border: none;
    outline: none;
    &::placeholder {
      color: #999;
    }
  }
}

.my-inputicon {
  position: absolute;
  left: 10px;
  top: 50%;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  transform: translateY(-50%);
  pointer-events: none;
}

.my-inputicon_phone {
  background-image: url(~@/assets/inputicon_phone.png);
}

.my-inputicon_psw {
  background-image: url(~@/assets/inputicon_psw.png);
}

.my-inputicon_code {
  background-image: url(~@/assets/inputicon_code.png);
}

.my-inputtip {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 3px;
  line-height: 20px;
  font-size: 14px;
  color: #ff2626;
}

.my-forgetpsw {
  position: absolute;
  margin-top: 3px;
  width: 100%;
  height: 21px;
  line-height: 21px;
  font-size: 15px;
  color: #4b85ff;
  text-align: right;
}

.my-loginbtn {
  margin-top: 30px;
  line-height: 50px;
  border-radius: 2px;
  font-size: 20px;
  color: #fff;
  background: #4b85ff;
  text-align: center;
}

.my-logindesc {
  margin-top: 10px;
  font-size: 13px;
  color: #a6a6a6;
  em {
    color: #4b85ff;
    cursor: pointer;
  }
}

.my-loginother {
  margin-top: 30px;
  line-height: 30px;
  font-size: 15px;
  color: #808080;
}

.my-loginby {
  margin-top: 20px;
  line-height: 30px;
  font-size: 15px;
  color: #808080;
}

.my-loginicon {
  display: inline-block;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 10px;
  cursor: pointer;
}

.my-loginicon_wx {
  background-image: url(~@/assets/loginicon_wx.png);
}

.my-loginicon_cg {
  background-image: url(~@/assets/loginicon_cg.png);
}

.my-imgverif-wrap {
  position: absolute;
  left: -50px;
  right: -50px;
  height: 100%;
}
</style>
